import { action } from '@play-co/replicant';
import createActions from 'src/replicant/config/actions/createActions';
import { setCurrentRegion } from './regions.modifiers';
import { getRegionId } from './regions.getters';

export const regionsActions = createActions({
  invalidateCurrentRegion: action((state, _, api) => {
    setCurrentRegion(state, getRegionId(state));
  }),
});
